<template>
    <section class="overlay -menu" v-if="isVisible" @click.self="hide">
        <div id="mobileMenu" class="mobile-menu" v-show="isVisible">
            <button class="button-hide" @click="hide"><i class="fa fa-times"></i></button>
            <div class="menu-container">
                <user-picture v-if="status" :user="user" :border="'-border-main'" />

                <user-card v-if="status" :user="user" />

                <the-navigation _class="-menu" />

                <!-- <user-contact v-if="status" :user="user" /> -->

                <nav-list
                    v-if="status"
                    :user="user"
                    :nav="user.social"
                    :_class="'-circle -border-light social-nav'"
                />
            </div>
        </div>
    </section>
</template>

<script>
    import NavList from '@/Components/NavList'
    import UserCard from '@/Components/User/UserCard'
    // import UserContact from '@/Components/User/UserContact'
    import UserPicture from '@/Components/User/UserPicture'
    import TheNavigation from '@/Components/TheNavigation'

    export default {
        components: {
            NavList,
            UserCard,
            // UserContact,
            UserPicture,
            TheNavigation,
        },

		props: {
            user: {
                type: Object,
                require: true,
                default() {
                    return {}
                },
            },
        },

        data() {
            return {
                isVisible: this.visible,
                userStatus: false,
            }
        },

        computed: {
			status() {
                return this.user ? true : false
            },
		},

        methods: {
            hide() {
                this.isVisible = false
                this.enableScroll()
            },

            show() {
                this.isVisible = true
                this.disableScroll()
            },

            disableScroll() {
                const $html = document.documentElement
                $html.classList.add('overlay-visible')
            },

            enableScroll() {
                const $html = document.documentElement
                $html.classList.remove('overlay-visible')
            },

            handleMouseup() {
                this.mousedown = false
                this.dragOffset = 0
            },

            handleMousedown(e) {
                if (!e.touches) {
                    e.preventDefault()
                }
                this.mousedown = true
                this.dragStartX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX
            },

            handleMousemove(e) {
                if (!this.mousedown) {
                    return
                }

                const eventPosX = 'ontouchstart' in window ? e.touches[0].clientX : e.clientX
                const deltaX = this.dragStartX - eventPosX
                this.dragOffset = deltaX

                if (this.dragOffset > this.minSwipeDistance) {
                    this.handleMouseup()
                    this.hide()
                } else if (this.dragOffset < -this.minSwipeDistance) {
                    this.handleMouseup()
                    // this.show();
                }
            },
        },

        mounted() {
            this.$root.$on('showMobileMenu', () => {
                this.show()
            })

            this.$root.$on('hideMobileMenu', () => {
                this.hide()
            })

            if ('ontouchstart' in window) {
                this.$el.addEventListener('touchstart', this.handleMousedown)
                this.$el.addEventListener('touchend', this.handleMouseup)
                this.$el.addEventListener('touchmove', this.handleMousemove)
            } else {
                this.$el.addEventListener('mousedown', this.handleMousedown)
                this.$el.addEventListener('mouseup', this.handleMouseup)
                this.$el.addEventListener('mousemove', this.handleMousemove)
            }
        },

        destroyed() {
            this.enableScroll()
        },
    }
</script>

<style lang="stylus"></style>
